import { HorizontalAlignType, PaletteColorType, PositionType, TextStyleType } from "../constants";
import { BaseCategory } from "./BaseCategory";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class SectionBreakCategory extends BaseCategory {
    get name() {
        return "Section Break";
    }

    get type() {
        return SlideCategories.SECTION_BREAK;
    }

    get icon() {
        return null;
    }

    get description() {
        return "This is a section break or chapter.";
    }

    getPrompt() {
        return `Provide a section or chapter number, title, and an optional subheadline.`;
    }

    getPromptSchema() {
        return {
            section_title: "the section or chapter title",
            subtitle: "optional subtitle (can be empty string if not needed)",
        };
    }

    getSlideModels(model, options = {}) {
        let models = [
            this.buildSection(model, options),
        ];

        return models;
    }

    buildSection(model, options = {}) {
        let builder = new SlideModelBuilder("headline2", model);

        builder.setBackgroundColor(`accent${Math.floor(Math.random() * 5) + 1}`);

        let blocks = [];
        blocks.push(builder.createBlock(`Section`, TextStyleType.CAPTION));

        if (model.section_title && typeof model.section_title == "string" && model.section_title.trim().length > 0) {
            let textStyle = model.section_title.length > 100 ? TextStyleType.HEADING : TextStyleType.HEADLINE;
            blocks.push(builder.createBlock(model.section_title, textStyle));
        }

        // Add subtitle if it exists and is not empty
        if (model.subtitle && typeof model.subtitle == "string" && model.subtitle.trim().length > 0) {
            blocks.push({ type: "divider", dividerWidth: "short" });
            blocks.push(builder.createBlock(model.subtitle, TextStyleType.BODY));
        } else if (model.subtitle && Array.isArray(model.subtitle)) {
            blocks.push(...model.subtitle);
        }

        let primary = {
            fullBleed: true,
            showGutter: false,
            headlinePosition: PositionType.CENTER,
            textPosition: PositionType.CENTER,
            textAlign: HorizontalAlignType.CENTER,
            text: {
                blocks
            }
        };
        builder.createPrimary(primary);

        // if (showImage && model.slideImage?.prompt) {
        //     primary.backdropStyle = "white_box";
        //     primary.items = [{
        //         componentType: "TextAndImage",
        //         childElement: builder.createImage(model.slideImage?.prompt, imageOptions, true)
        //     }];
        // } else {
        //     builder.setBackgroundColor(PaletteColorType.ACCENT1);
        // }

        if (options.citeSources) {
            builder.createSourcesAttribution(model.sources);
        }

        return builder.model;
    }
}
